import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getByRemission(remissionId) {
        return axios.get(`${API_URL}/remission-payments?remission_id=${remissionId}`, { headers: authHeader() });
    },
    store(data) {
        return axios.post(`${API_URL}/remission-payments`, data, { headers: authHeader() });
    },
    destroy(id) {
        return axios.delete(`${API_URL}/remission-payments/${id}`, { headers: authHeader() });
    },
};
